/**
 * Composable pour l'assignation de commercial dans le détail d'une quote
 * Limite: 100 lignes max
 */

import { toast } from 'vue-sonner'
import { quotesService } from '../../services/index.js'
import { buildAssignmentToastMessage } from '../../utils/assignmentToast.js'

export function useQuoteDetailAssign(
  quoteId,
  quote,
  availableCommercials,
  currentUser,
  loadQuote
) {
  const assignCommercial = async (userId) => {
    try {
      const isUnassigning = userId === '' || userId === null
      // Qui était assigné AVANT le changement (pour formuler le message de désassignation)
      const previousAssignedId = quote.value?.assigned_user_id ?? null

      const data = await quotesService.assign(quoteId, userId === '' ? null : parseInt(userId))
      quote.value = data

      toast.success(buildAssignmentToastMessage({
        isUnassigning,
        previousAssignedId,
        assignedId: isUnassigning ? null : parseInt(userId),
        currentUserId: currentUser.value?.id,
        availableCommercials: availableCommercials.value
      }))
    } catch (err) {
      toast.error(err.message || 'Erreur lors de l\'assignation')
      console.error(err)
      await loadQuote()
      throw err
    }
  }

  return {
    assignCommercial
  }
}
